import SubcategoriesList from './SubcategoriesList'
export default SubcategoriesList
